export default __webpack_public_path__ + "111721192039b3464b23f3a5faa6a8f3.svg";